import { useEffect } from "react";
import { alertService, RequestStatus } from "common-frontend-components";
import { sitePhotoStore } from "../../../stores/appConfig/sitePhotoStore";
import { callGetSitePhotoGroupsAsync, callGetSitePhotosAsync } from "../../../apis/sitePhotos";
import { sitePhotoGroupStore } from "../../../stores/appConfig/sitePhotoGroupStore";
export const useAdminGetSitePhotos = () => {
    const status = sitePhotoStore.useStatus();
    useEffect(() => {
        if (sitePhotoStore.getStatus() !== RequestStatus.pending)
            return;
        sitePhotoStore.setStatus(RequestStatus.loading);
        callGetSitePhotosAsync()
            .then((items) => {
            sitePhotoStore.setData(items);
            sitePhotoStore.setStatus(RequestStatus.loaded);
        })
            .catch((e) => {
            alertService.error(e);
            sitePhotoStore.setStatus(RequestStatus.failed);
        });
    }, []);
    return status;
};
export const useAdminGetSitePhotoGroups = () => {
    const status = sitePhotoGroupStore.useStatus();
    useEffect(() => {
        if (sitePhotoGroupStore.getStatus() !== RequestStatus.pending)
            return;
        sitePhotoGroupStore.setStatus(RequestStatus.loading);
        callGetSitePhotoGroupsAsync()
            .then((items) => {
            sitePhotoGroupStore.setData(items);
            sitePhotoGroupStore.setStatus(RequestStatus.loaded);
        })
            .catch((e) => {
            alertService.error(e);
            sitePhotoGroupStore.setStatus(RequestStatus.failed);
        });
    }, []);
    return status;
};
//# sourceMappingURL=useGetSitePhotos.js.map